import React from 'react'
import { useAccountOpeningQuota } from '../../../../AccountOpeningWizard/hooks/useAccountOpeningQuota'

const SCHWAB_HOW_IT_WORKS_BASE = [
  'Connect securely through Schwab Advisor Center. Zocks only sees the accounts you already have access to in Schwab',
  'Pull balances, cash, holdings, transactions, per-lot cost basis and realized/unrealized gains into meeting prep',
  'Ask anything about a client’s Schwab account and get answers mid-meeting',
  'Use Schwab data to fill out forms',
  'Data is pulled on demand, so it’s current the moment you ask',
]

const SCHWAB_HOW_IT_WORKS_ULTIMATE = [
  'Fill out Schwab Digital Onboarding applications from meetings, emails and connected CRM and planning systems',
  'Catch missing or conflicting fields before submission, checked against Schwab’s requirements',
  'Open accounts for new clients or add accounts for existing ones',
  'Track every application from submitted to signed. Clients still sign through Schwab Alliance',
  'Pull balances, holdings, cost basis and gains into meeting prep, so the data is current the moment you ask',
  'Ask anything about a client’s Schwab account and get answers mid-meeting',
  'Use Schwab data to draft emails and fill out forms',
]

export const SchwabHowItWorks: React.FC = () => {
  const { enabled } = useAccountOpeningQuota()
  const lines = enabled ? SCHWAB_HOW_IT_WORKS_ULTIMATE : SCHWAB_HOW_IT_WORKS_BASE

  return (
    <div>
      <ul>
        {lines.map((line, i) => (
          <li key={i}>{line}</li>
        ))}
      </ul>
    </div>
  )
}
